export const LOGIN_PAGE_MESSAGE_CREATED = 'login_page_message_created';
export const addLoginPageMessageCreated = (messageBody, messageType) => ({
  type: LOGIN_PAGE_MESSAGE_CREATED,
  messageBody,
  messageType,
});

export const LOGIN_PAGE_MESSAGE_CLEARED = 'login_page_message_cleared';
export const addLoginPageMessageCleared = () => ({ type: LOGIN_PAGE_MESSAGE_CLEARED });
